import { ApplicationsServiceV4 } from 'services/v4/applications-v4.service'

/* Per tab, so it survives the round trip through the provider but not into another tab's setup. */
const STORAGE_KEY = 'onyxia.unsavedApplicationId'

let discarding: Promise<void> | null = null

const read = (): string | null => {
  try {
    return sessionStorage.getItem(STORAGE_KEY)
  } catch {
    return null
  }
}

/* The instance a setup created and has not saved yet. */
export const rememberUnsavedApplication = (id: string) => {
  try {
    sessionStorage.setItem(STORAGE_KEY, id)
  } catch {
    /* Without storage an abandoned instance stays, as it did before. */
  }
}

export const forgetUnsavedApplication = () => {
  try {
    sessionStorage.removeItem(STORAGE_KEY)
  } catch {
    /* Nothing to forget. */
  }
}

/* Removes the instance a setup left without Save, however it was left: browser Back through the
 * provider's pages never reaches the setup page's own Cancel. Lists await it so they never show it. */
export const discardAbandonedApplication = (keepId?: string): Promise<void> => {
  const id = read()
  if (!id || id === keepId) return discarding ?? Promise.resolve()

  forgetUnsavedApplication()
  discarding = ApplicationsServiceV4.removeApplication(id)
    .catch((e) => console.error(e))
    .finally(() => {
      discarding = null
    })

  return discarding
}
